import { render, staticRenderFns } from "./invite-query.vue?vue&type=template&id=ede4938e&scoped=true"
import script from "./invite-query.vue?vue&type=script&lang=js"
export * from "./invite-query.vue?vue&type=script&lang=js"
import style0 from "./invite-query.vue?vue&type=style&index=0&id=ede4938e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede4938e",
  null
  
)

export default component.exports